<template>
  <teleport to="body">
    <div class="modalBox type1">
      <div class="inner">
        <h2 class="title">
          <slot name="header">提醒訊息 </slot>
          <div v-if="modalSetting && modalSetting.noClose"></div>
          <img
            v-else
            @click="$emit('close')"
            style="float:right;"
            src="@/assets/images/modal_close.svg"
          />
        </h2>
        <p
          style="max-height: 60vh; overflow: auto; margin-bottom: 25px; white-space: pre-wrap;"
        >
          <slot name="body"></slot>
        </p>
        <div class="btnsSchedule" v-if="modalSetting?.schedules">
          <button class="btnDisabled">
            <div class="schedule">
              <div>
                {{ modalSetting.period.班別 }}診 {{ modalSetting.period.診別 }}
              </div>
              <div>
                <div class="dr">
                  {{ modalSetting.period.醫師名 }} 醫師<br />
                </div>
                <div class="num">網掛額滿</div>
              </div>
              <div class="make">
                <a
                  style="color: #9a9a9a;"
                  :href="`tel:${modalSetting.telNumber}`"
                >
                  請來電洽詢按 1<br />
                  <span style="font-size: 0.6rem;">按此撥號</span>
                </a>
              </div>
            </div>
          </button>
          <button
            class="btn"
            v-for="(s, idx) in modalSetting.schedules"
            :key="idx"
          >
            <div class="schedule">
              <div>{{ s.班別 }}診 {{ s.診別 }}</div>
              <div>
                <div class="dr">{{ s.醫師名 }} 醫師<br /></div>
                <div class="num">預約號碼 {{ s.就診參考序號 }}</div>
              </div>
              <div class="make" @click="$emit('makeOthers', s)">預約</div>
            </div>
          </button>
        </div>
        <div v-else class="btns">
          <slot name="footer">
            <button
              v-if="modalSetting && modalSetting.isShowTel"
              class="btn"
              style="width: 15em;"
              @click="$emit('close')"
            >
              <a style="color: white;" :href="`tel:${modalSetting.telNumber}`"
                >請來電洽詢其他門診</a
              >
            </button>
            <button
              v-if="modalSetting && modalSetting.isShowUrl"
              class="btn"
              @click="$emit('close')"
            >
              <a
                style="color: white;"
                @click="openWindow(`${modalSetting.url}`)"
                >{{ modalSetting.urlTitle }}</a
              >
            </button>
            <button
              v-if="modalSetting && modalSetting.isShowConfirm"
              class="btn"
              @click="$emit('confirm')"
            >
              <a style="color: white;">確定送出</a>
            </button>
            <button
              v-if="modalSetting && modalSetting.isShowUnderstand"
              class="btn"
              @click="$emit('understand')"
            >
              <a style="color: white;">我瞭解了</a>
            </button>
          </slot>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import liff from "@line/liff";
export default {
  name: "Modal",
  props: ["modalSetting"],
  emits: ["close", "confirm", "understand", "makeOthers"],
  methods: {
    openWindow(url) {
      liff.openWindow({
        url,
        external: true
      });
    }
  }
};
</script>

<style scoped>
div.btnsSchedule .btn {
  width: 100%;
  background-color: #e98112;
  margin: 6px 0;
  border-radius: 5px;
  padding: 1rem;
  color: white;
}
div.btnsSchedule .btnDisabled {
  width: 100%;
  background-color: #7a7a7a;
  margin: 6px 0;
  border-radius: 5px;
  padding: 1rem;
  color: #9a9a9a;
}
div.schedule {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  text-align: center;
  align-items: center;
}
div.schedule .dr {
  font-size: 18px;
}
div.schedule .num {
  margin-top: 12px;
  font-size: 14px;
}
div.schedule .make {
  width: 100%;
  padding-right: 1rem;
  text-align: right;
}
</style>
